export interface IBaseQueryParameters {
  // For adding query parameters not defined in the interface
  [key: string]: any

  /**
   * An optional parameter to specify the format of the data returned by the
   * API. If not specified, the value of the `responseFormat` property of the
   * `config` object is used, which defaults to `json` if not provided.
   */
  format?: 'json' | 'xml'

  /**
   * An optional parameter to specify an API key for the individual request. If
   * not specified, the value of the `apiKey` property of the `config` object is
   * used, which defaults to `NoKeyProvided` if not provided.
   */
  api_key?: string

  /**
   * An optional parameter to specify the number of results to return per page.
   * If not specified, the default value of `20` is used.
   */
  limit?: number

  /**
   * An optional parameter to specify the number of items to offset the results
   * by. If not specified, the default value of `0` is used.
   */
  offset?: number
}
